var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.features),function(feature){return _c('base-info-card',{key:feature,attrs:{"title":feature}},[_c('a',{staticClass:"mb-8 grey--text text-body-1 d-block text-none",attrs:{"text":feature,"href":"#"},domProps:{"innerHTML":_vm._s(`&rsaquo; ${feature} ansehen`)}})])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }